<template>
    <section>
        <div class='mb-4'>
            <conversion-component :courses="courses" :crypto="cryptos" @convert="convert" :balances="balances" :myMethods="myMethods"></conversion-component>
        </div>
    </section>
</template>
<script>
   import ConversionComponent from "@/components/Actives/ConversionComponent.vue";
  export default {
      props: [
          'courses',
          'cryptos',
          'balances',
          'currencies',
          'myMethods'
      ],
      components: {
        ConversionComponent,
      },
      methods: {
          convert(data){
                this.$emit('convert');
            },
      },
      mounted() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
  }
</script>

